import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CHART_STRINGS } from '../helpers/graphConstants';

const ApproximateDialysisLabel = ({ viewBox }) => {
  const { x, y } = viewBox;
  if (x === undefined || y === undefined) {
    return null;
  }

  const LABEL_OFFSET = 40;
  const labelX = x + LABEL_OFFSET;
  const labelY = y;

  return (
    <g>
      <text
        x={labelX}
        y={labelY}
        className="approximate-dialysis-label"
        textAnchor="start"
      >
        <tspan x={labelX} dy="-1.5em">
          {CHART_STRINGS.APPROXIMATE_DIALYSIS_LABEL_L1}
        </tspan>
        <tspan x={labelX} dy="1.2em">
          {CHART_STRINGS.APPROXIMATE_DIALYSIS_LABEL_L2}
        </tspan>
        <tspan x={labelX} dy="1.2em">
          {CHART_STRINGS.APPROXIMATE_DIALYSIS_LABEL_L3}
        </tspan>
      </text>
    </g>
  );
};

ApproximateDialysisLabel.propTypes = {
  viewBox: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};

export default memo(ApproximateDialysisLabel);
